import 'arrive';
import $ from 'jquery';

document.arrive('header', { existing: true }, function () {
    const $header = $(this);
    let lastScrollTop = 0;
    const headerHeight = $header.outerHeight() + 20;
    let ticking = false;
    
    // Imposta l'header come fixed dall'inizio
    $header.css({
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        zIndex: '1000'
    });
    
    // Aggiungi padding-top al body per compensare l'header fisso
    const isHome = $('body').hasClass('home');
    const extraPadding = isHome ? 0 : 30;
    const bodyPadding = ($(window).width() <= 550 ? 10 : headerHeight) + extraPadding;
    $('body').css('padding-top', bodyPadding + 'px');
    $('.search-bar').css('top', bodyPadding + 'px');
    
    function updateHeader() {
        const currentScrollTop = $(window).scrollTop();
        
        // Se siamo in cima alla pagina
        if (currentScrollTop <= 0) {
            $header.css('transform', 'translateY(0)');
        }
        // Scroll down - nascondi header
        else if (currentScrollTop > lastScrollTop && currentScrollTop > headerHeight) {
            $header.css('transform', 'translateY(-100%)');
        }
        // Scroll up - mostra header
        else if (currentScrollTop < lastScrollTop) {
            $header.css('transform', 'translateY(0)');
        }
        
        lastScrollTop = currentScrollTop;
        ticking = false;
    }
    
    $(window).on('scroll', function() {
        if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
        }
    });
    
    // Gestione menu mobile - espandi header a tutto schermo e blocca scroll
    const $offcanvas = $('#mobileMenu');
    const $body = $('body');
    
    // Monitora quando Bootstrap aggiunge/rimuove la classe 'show'
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = $(mutation.target);
                
                if (target.hasClass('show') && $(window).width() <= 991) {
                    // Offcanvas è aperto
                    $header.addClass('mobile-menu-open');
                    $body.addClass('offcanvas-open');
                } else {
                    // Offcanvas è chiuso
                    $header.removeClass('mobile-menu-open');
                    $body.removeClass('offcanvas-open');
                }
            }
        });
    });
    
    // Osserva i cambiamenti di classe sull'offcanvas
    observer.observe($offcanvas[0], {
        attributes: true,
        attributeFilter: ['class']
    });
});